// Ant Design Global Overrides - converted from styled-components
import "./antOverride.css";

// AntOverride component that imports the CSS
export function AntOverride() {
  return null;
}
